// ==============================================================================
// Medio de Contacto Talento
// ==============================================================================

export const TLT_CONTACTO_NUM_NEXION = "NEXION";

// ==============================================================================
// Origen Curriculum Talento
// ==============================================================================

export const TLT_ORIGENCV_NUM_CORREO = "CORREO";
export const TLT_ORIGENCV_NUM_LINKED = "LINKED";
export const TLT_ORIGENCV_NUM_COMPUT = "COMPUT";
export const TLT_ORIGENCV_NUM_WHATSA = "WHATSA";
export const TLT_ORIGENCV_NUM_RECOMD = "RECOMD";
export const TLT_ORIGENCV_NUM_NEXION = "NEXION";
export const TLT_ORIGENCV_NUM_NSTLNT = "NSTLNT";
export const TLT_ORIGENCV_NUM_INDEED = "INDEED";
export const TLT_ORIGENCV_NUM_INJOBS = "INJOBS";
export const TLT_ORIGENCV_NUM_GLJOBS = "GLJOBS";
export const TLT_ORIGENCV_NUM_INSTAG = "INSTAG";
export const TLT_ORIGENCV_NUM_FACEBK = "FACEBK";

export const TLT_ORIGENCV_ENCRIPTED = {
  xytl: TLT_ORIGENCV_NUM_CORREO
  , bcvn: TLT_ORIGENCV_NUM_LINKED
  , yton: TLT_ORIGENCV_NUM_COMPUT
  , fddr: TLT_ORIGENCV_NUM_WHATSA
  , qwer: TLT_ORIGENCV_NUM_RECOMD
  , vgug: TLT_ORIGENCV_NUM_NEXION
  , nsdj: TLT_ORIGENCV_NUM_NSTLNT
  , indd: TLT_ORIGENCV_NUM_INDEED
  , injs: TLT_ORIGENCV_NUM_INJOBS
  , gljs: TLT_ORIGENCV_NUM_GLJOBS
  , inst: TLT_ORIGENCV_NUM_INSTAG
  , fcbk: TLT_ORIGENCV_NUM_FACEBK
};

// ==============================================================================
//  Tipo Teléfono Talento
// ==============================================================================

export const TLT_TIPOTELEFONO_CELU = "CELULAR";
export const TLT_TIPOTELEFONO_CASA = "CASA";

export const TLT_TIPOTELEFONO_NUM_CELU = "CELULAR";
export const TLT_TIPOTELEFONO_NUM_CASA = "CASA";

export const TLT_TIPOTELEFONO_SELECT = [
  { code: TLT_TIPOTELEFONO_NUM_CELU, name: TLT_TIPOTELEFONO_CELU }
  , { code: TLT_TIPOTELEFONO_NUM_CASA, name: TLT_TIPOTELEFONO_CASA }
];

// ==============================================================================
//  Tipo Usuario Talento
// ==============================================================================

export const TLT_TIPOUSUARIO_WHATSAPP = "WHATSAPP";

export const TLT_TIPOUSUARIO_NUM_WHATSAPP = "WHATSAPP";

export const TLT_TIPOUSUARIO_SELECT = [
  { code: TLT_TIPOUSUARIO_NUM_WHATSAPP, name: TLT_TIPOUSUARIO_WHATSAPP }
];

// ==============================================================================
//  Idioma Talento
// ==============================================================================

export const TLT_IDIOMA_ES = "ESPAÑOL";
export const TLT_IDIOMA_IN = "INGLÉS";
export const TLT_IDIOMA_FR = "FRANCÉS";
export const TLT_IDIOMA_PG = "PORTUGUES";
export const TLT_IDIOMA_RU = "RUSO";
export const TLT_IDIOMA_CH = "CHINO";
export const TLT_IDIOMA_IT = "ITALIANO";
export const TLT_IDIOMA_AL = "ALEMÁN";

export const TLT_IDIOMA_NUM_ES = "ESPAÑOL";
export const TLT_IDIOMA_NUM_IN = "INGLÉS";
export const TLT_IDIOMA_NUM_FR = "FRANCÉS";
export const TLT_IDIOMA_NUM_PG = "PORTUGUES";
export const TLT_IDIOMA_NUM_RU = "RUSO";
export const TLT_IDIOMA_NUM_CH = "CHINO";
export const TLT_IDIOMA_NUM_IT = "ITALIANO";
export const TLT_IDIOMA_NUM_AL = "ALEMÁN";

export const TLT_IDIOMA_SELECT = [
  { code: TLT_IDIOMA_NUM_ES, name: TLT_IDIOMA_ES }
  , { code: TLT_IDIOMA_NUM_IN, name: TLT_IDIOMA_IN }
  , { code: TLT_IDIOMA_NUM_FR, name: TLT_IDIOMA_FR }
  , { code: TLT_IDIOMA_NUM_PG, name: TLT_IDIOMA_PG }
  , { code: TLT_IDIOMA_NUM_RU, name: TLT_IDIOMA_RU }
  , { code: TLT_IDIOMA_NUM_CH, name: TLT_IDIOMA_CH }
  , { code: TLT_IDIOMA_NUM_IT, name: TLT_IDIOMA_IT }
  , { code: TLT_IDIOMA_NUM_AL, name: TLT_IDIOMA_AL }
];

// ==============================================================================
//  Nivel de Idioma Talento
// ==============================================================================

export const TLT_NIVEL_IDIOMA_N = "NATIVO";
export const TLT_NIVEL_IDIOMA_C2 = "BILINGÜE C2";
export const TLT_NIVEL_IDIOMA_C1 = "AVANZADO C1";
export const TLT_NIVEL_IDIOMA_B2 = "INTERMEDIO AVANZADO B2";
export const TLT_NIVEL_IDIOMA_B1 = "INTERMEDIO B1";
export const TLT_NIVEL_IDIOMA_A2 = "BÁSICO AVANZADO A2";
export const TLT_NIVEL_IDIOMA_A1 = "BÁSICO A1";

export const TLT_NIVEL_IDIOMA_NUM_N = "NATIVO";
export const TLT_NIVEL_IDIOMA_NUM_C2 = "C2";
export const TLT_NIVEL_IDIOMA_NUM_C1 = "C1";
export const TLT_NIVEL_IDIOMA_NUM_B2 = "B2";
export const TLT_NIVEL_IDIOMA_NUM_B1 = "B1";
export const TLT_NIVEL_IDIOMA_NUM_A2 = "A2";
export const TLT_NIVEL_IDIOMA_NUM_A1 = "A1";

export const TLT_NIVEL_IDIOMA_SELECT = [
  { code: TLT_NIVEL_IDIOMA_NUM_N, name: TLT_NIVEL_IDIOMA_N }
  , { code: TLT_NIVEL_IDIOMA_NUM_C2, name: TLT_NIVEL_IDIOMA_C2 }
  , { code: TLT_NIVEL_IDIOMA_NUM_C1, name: TLT_NIVEL_IDIOMA_C1 }
  , { code: TLT_NIVEL_IDIOMA_NUM_B2, name: TLT_NIVEL_IDIOMA_B2 }
  , { code: TLT_NIVEL_IDIOMA_NUM_B1, name: TLT_NIVEL_IDIOMA_B1 }
  , { code: TLT_NIVEL_IDIOMA_NUM_A2, name: TLT_NIVEL_IDIOMA_A2 }
  , { code: TLT_NIVEL_IDIOMA_NUM_A1, name: TLT_NIVEL_IDIOMA_A1 }
];

// ==============================================================================
//  Nivel de Habilidad Talento
// ==============================================================================

export const TLT_NIVEL_HABILIDAD_B = "BÁSICO";
export const TLT_NIVEL_HABILIDAD_I = "INTERMEDIO";
export const TLT_NIVEL_HABILIDAD_A = "AVANZADO";

export const TLT_NIVEL_HABILIDAD_NUM_B = "BASICO";
export const TLT_NIVEL_HABILIDAD_NUM_I = "INTERMEDIO";
export const TLT_NIVEL_HABILIDAD_NUM_A = "AVANZADO";

export const TLT_NIVEL_HABILIDAD_SELECT = [
  { code: TLT_NIVEL_HABILIDAD_NUM_A, name: TLT_NIVEL_HABILIDAD_A }
  , { code: TLT_NIVEL_HABILIDAD_NUM_I, name: TLT_NIVEL_HABILIDAD_I }
  , { code: TLT_NIVEL_HABILIDAD_NUM_B, name: TLT_NIVEL_HABILIDAD_B }
];



// WEBPACK FOOTER //
// ./src/constants/operativos.js